import React from 'react';
import { NavLinkV3 } from './NavLinkV3.js';
import { getSubNavDividerClasses, getSubNavListTitleClasses } from './subNavListItem.logic.js';
export function SubNavListItemV3({ item, isWithinNavGroup }) {
    const { title } = item;
    const type = 'type' in item ? item.type : 'section';
    const children = 'children' in item ? item.children : undefined;
    return (React.createElement(React.Fragment, null, children ? (React.createElement(React.Fragment, null,
        type === 'group' && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: getSubNavDividerClasses() }),
            React.createElement("span", { className: getSubNavListTitleClasses('twds-text-white twds-h-4') }, title),
            children.map((child) => (React.createElement(SubNavListItemV3, { key: child.id, item: child, isWithinNavGroup: true }))))),
        type === 'section' && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: getSubNavListTitleClasses('twds-h-4') }, title),
            children.map((child) => (React.createElement(NavLinkV3, { key: child.id, ...child, className: isWithinNavGroup ? 'twds-pl-6' : 'twds-pl-4' }))))))) : (React.createElement(NavLinkV3, { ...item }))));
}
//# sourceMappingURL=SubNavListItemV3.js.map